import { Card } from "@pushpress/pushpress-ui";
import { CheckCircle2 } from "lucide-react";
import { useDevice } from "@pushpress/shared-components";
import { useAnalytics } from "../../../components/providers/AnalyticsProvider/AnalyticsProvider";
import { USER_UUID, CLIENT_UUID } from "../constants";

type SuccessScreenProps = {
  logoUrl: string;
  gymName: string;
};

export default function SuccessScreen({
  logoUrl,
  gymName,
}: SuccessScreenProps) {
  const { trackEvent } = useAnalytics();
  const { isMobile } = useDevice();

  const userUuid = sessionStorage.getItem(USER_UUID);
  const clientUuid = sessionStorage.getItem(CLIENT_UUID);

  trackEvent("Add Payment Success Screen Viewed", {
    is_mobile: isMobile,
    user_uuid: userUuid,
    client_uuid: clientUuid,
  });

  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-blue-600 tw-p-4">
      <Card className="tw-w-full tw-max-w-md tw-space-y-8 tw-p-8">
        {logoUrl && (
          <div className="tw-flex tw-justify-center">
            <div className="tw-w-16 tw-h-16 tw-rounded-xl tw-p-4">
              <img
                data-testid="gym-logo"
                src={logoUrl}
                width="50px"
                className="tw-mb-1"
                alt="gym logo"
              />
            </div>
          </div>
        )}
        <div className="tw-space-y-4 tw-text-center">
          <h1 className="tw-text-2xl tw-font-semibold tw-text-gray-900">
            Complete
          </h1>
          <p className="tw-text-xl tw-text-gray-600">Payment method added</p>
        </div>
        <div className="tw-flex tw-justify-center">
          <div className="tw-rounded-full tw-bg-white tw-p-4">
            <CheckCircle2 className="tw-w-16 tw-h-16 tw-text-blue-600" />
          </div>
        </div>
        <div className="tw-text-center tw-text-gray-600">
          {gymName} has been notified.
        </div>
      </Card>
    </div>
  );
}
